import React from "react";

function LiveIcon() {
  return (
    <svg
      width="36"
      height="22"
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 36 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V18C36 20.2091 34.2091 22 32 22H4C1.79086 22 0 20.2091 0 18V4Z"
        fill="#34C759"
      />
      <path
        d="M10.698 13.392V15H5.14195V6.684H7.01395V13.392H10.698ZM12.2837 6.684H14.1557V15H12.2837V6.684ZM18.9325 15C18.6045 14.304 18.2805 13.58 17.9605 12.828C17.6405 12.076 17.3365 11.332 17.0485 10.596C16.7605 9.86 16.4925 9.156 16.2445 8.484C16.0045 7.812 15.7965 7.212 15.6205 6.684H17.6845C17.8445 7.164 18.0165 7.684 18.2005 8.244C18.3925 8.796 18.5845 9.348 18.7765 9.9C18.9765 10.452 19.1685 10.98 19.3525 11.484C19.5365 11.988 19.7085 12.424 19.8685 12.792C20.0205 12.424 20.1885 11.988 20.3725 11.484C20.5645 10.98 20.7565 10.452 20.9485 9.9C21.1485 9.348 21.3405 8.796 21.5245 8.244C21.7165 7.684 21.8925 7.164 22.0525 6.684H24.0445C23.8605 7.212 23.6485 7.812 23.4085 8.484C23.1685 9.156 22.9045 9.86 22.6165 10.596C22.3285 11.332 22.0245 12.076 21.7045 12.828C21.3845 13.58 21.0605 14.304 20.7325 15H18.9325ZM25.5007 15V6.684H31.1167V8.256H27.3727V9.888H30.6967V11.424H27.3727V13.428H31.3927V15H25.5007Z"
        fill="white"
      />
    </svg>
  );
}

export default LiveIcon;
